export default __webpack_public_path__ + "static/06-cadd7c9cf6214755f7eb9af5b6e6dfbc.webp";